<fgb-banner [pageTitle]="'faq.page.title' | translate"></fgb-banner>
<fgb-page-header [pageTitle]="'faq.page.title'" [showBalance]="false" [showFooter]="true" [backButtonLink]="'/'" />

<div class="container">
  <fgbcl-faq-section></fgbcl-faq-section>
</div>
